module.exports = __webpack_public_path__ + "img/SAVE.482c3529.svg";